import {
  FitnessApplicationActivityType,
  MeasurementSystem,
} from '../../../../types/__generated__';
import { FitnessSettingsFormValues } from '../FitnessSettingsForm/FitnessSettingsForm';

export const defaultFitnessSettings = (
  subscribedActivities = Object.values(FitnessApplicationActivityType),
): FitnessSettingsFormValues => ({
  subscribedActivities,
  measurementSystem: MeasurementSystem.Imperial,
  showDistance: true,
  showDuration: true,
  showElevation: true,
  showPhotos: true,
  showMap: true,
  showTotaliser: true,
});

export const pausedFitnessSettings: FitnessSettingsFormValues = {
  ...defaultFitnessSettings(),
  subscribedActivities: [],
};
